import Store from 'store/store';
import cached from 'utils/cached';
import { getDataDomain } from 'utils/dynamicData';

const fetchJson = cached(async url => {
	if (!url) return null;
	try {
		const res = await fetch(url);
		if (!res.ok) {
			throw new Error(`Unable to fetch cms data`);
		}
		return await res.json();
	} catch (err) {
		console.error('[fetchJson] Error fetching JSON:', err);
		return null;
	}
}, url => url);

async function getAllDomains() {
	const dataDomain = getDataDomain();
	return await fetchJson(new URL('cms/domains.json', dataDomain));
}

async function getAltLangDomain() {
	const altLangRegion = (Store.get().appData?.options?.altLangRegion?.toLowerCase());
	if (!altLangRegion) return null;

	const data = await getAllDomains();
	if (!data) return null;
	const domainName = data?.domains?.find(domain => domain.region_code?.toLowerCase() === altLangRegion)?.domain_name || null;
	return domainName ? `https://${domainName}` : null;
}

export async function getAltLangMovieUrl() {
	const baseMovieId = Store.get().appData?.meta?.cms_base_id;
	if (!baseMovieId) return null;

	const altLangDomain = await getAltLangDomain();
	if (!altLangDomain) return null;

	const altLangMovieData = await fetchJson(new URL(`cms/movies/base/${baseMovieId}.json`, altLangDomain));
	if (!altLangMovieData) return null;

	return altLangMovieData.url || `${altLangDomain}/movies/${altLangMovieData.slug}`;
}